import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    max-width: 390px;
    width: 100%;
    margin: 8px;
    z-index: 1;
    flex: 1;
    position: absolute;
    left: 0;
    bottom: 3px;
    height: calc(100vh - 150px);
    top: 11.8rem;
`;

const LeftColumn = ({children}) => (
    <Container>{children}</Container>
);

export default LeftColumn;
